import styled from 'styled-components'
import { Pagination, Empty, Image } from 'antd'
import { IconFont, SvgIcon } from '@/components'
import {
  useGetAttachments,
  useDelAttachmentDetail,
  useGetAttachmentsDownload,
  useGetEducationTemplateList,
} from './utils'
import { useEffect, useState } from 'react'
import { GetEducationTemplateList } from '@/api/template'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { t } from '@/i18n'

export const EducationTemplate = () => {
  const [filterParams, setFilterParams] = useState<GetEducationTemplateList>({
    limit: 20,
    page: 1,
    keyword: '',
  })
  const [templateList, getTemplateList] = useGetEducationTemplateList()
  useEffect(() => {
    getTemplateList({ ...filterParams }).catch(_ => {})
  }, [filterParams])
  // const [templateList] = useState({
  //   items: [
  //     { name: '模板名称12', url: 'du321423dud', cover: 'src' },
  //     { name: '模板名称32', url: 'du564ytgadsfdud', cover: 'src' },
  //   ],
  //   total: 2,
  // })

  const [visibles, setVisibles] = useState({ visible: false, cover: '' })

  return (
    <Main>
      <TemplateContainer>
        {templateList.items?.map(item => (
          <div className="template" key={item?.id}>
            <div className="top">
              <div className="img-main">
                <Image
                  width={'64px'}
                  fallback={`${
                    process.env.NODE_ENV === 'dev' ? '/api' : ''
                  }/static/default/phishPage.png`}
                  src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${item?.cover}`}
                  preview={false}
                />
              </div>
              <div className="headline">
                <div className="title">{item?.name}</div>
                <div className="text">
                  URL：
                  <a target="_blank" href={item?.redirect} rel="noopener noreferrer">
                    {item?.redirect || '-'}
                  </a>
                </div>
              </div>
            </div>
            <a target="_blank" href={item?.redirect} rel="noopener noreferrer">
              <div className="examine">
                <div className="operation">
                  <IconFont type={'icon-chakan'} /> {t('预览')}
                </div>
              </div>
            </a>
          </div>
        ))}
      </TemplateContainer>
      {templateList.items?.length > 0 && (
        <div className="pagination">
          <Pagination
            onChange={(page, limit) => {
              setFilterParams(origin => ({ ...origin, page, limit }))
            }}
            defaultCurrent={1}
            total={templateList?.total}
            showSizeChanger
            showQuickJumper
            current={filterParams.page}
            pageSize={filterParams.limit}
            defaultPageSize={20}
            pageSizeOptions={['20', '40', '60', '80', '100']}
            showTotal={totals => (
              <div>
                {t('共')}
                <a>{totals}</a>
                {t('条')}
              </div>
            )}
          />
        </div>
      )}
      {!templateList?.items && <Empty image={EmptyImg} />}
      <Image
        key={visibles?.cover}
        style={{ display: 'none' }}
        preview={{
          visible: visibles.visible,
          src: `${process.env.NODE_ENV === 'dev' ? '/api' : ''}${visibles?.cover}`,
          onVisibleChange: value => {
            setVisibles({ visible: value, cover: '' })
          },
        }}
      />
    </Main>
  )
}
const TemplateContainer = styled.div`
  padding: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(327px, 1fr));
  grid-gap: 20px;
  .template {
    height: 141px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    display: flex;
    position: relative;
    overflow: hidden;
    .top {
      width: 100%;
      background: #ffffff;
      padding: 16px 24px;
      height: calc(100% - 32px);
      display: flex;
      align-items: center;
    }

    .img-main {
      width: 64px;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      height: 85px;
      align-items: center;
      border: 2px solid #edeeec;
      //background: #efeeec;
    }
  }
  .headline {
    margin-left: 20px;
    width: calc(100% - 84px);
    .title {
      color: #333;
      font-weight: 700;
      line-height: 1.2;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
    .text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      color: #666;
      margin-top: 16px;
      font-size: 13px;
      line-height: 1.2;
    }
  }
  .examine {
    height: 30px;
    background: #f1f1f1;
    border-radius: 0px 0px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
    width: 100%;
    .operation {
      flex: 1;
      text-align: center;
      border-left: 1px solid #d9d9d9;
      &:nth-child(1) {
        border: 0;
      }
    }
  }
`
const Main = styled.div`
  padding: 0 20px;
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
`
